import * as ReactService from "@intech/react-service";

class Formularios extends ReactService.BaseService {
  constructor() {
    super("Formularios");
  }

  BaixarDesignacaoDependentes = (cdPlano: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BaixarDesignacaoDependentes/${cdPlano}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const FormulariosService = new Formularios();
